export function mapSerializeOperator(node, ctx) {
    const columns = [];
    const listNode = ctx.getChild(node, "IdentifierList");
    if (listNode) {
        const identifiers = ctx.getChildren(listNode, "Identifier");
        for (const id of identifiers)
            columns.push(ctx.slice(id));
    }
    return {
        type: "SerializeOperator",
        columns,
        start: node.from,
        end: node.to,
    };
}
